import { ConfidentialityDecision } from 'types/caseClosing';

export function isConfidentialityChoiceValid(
    isConfidential: boolean,
    decision: ConfidentialityDecision | null,
    reason: string,
    isReasonRequired: boolean
): boolean {
    if (!isConfidential) {
        return true;
    }
    if (decision === ConfidentialityDecision.SWITCH_OFF) {
        return true;
    }
    if (decision === ConfidentialityDecision.KEEP) {
        return !isReasonRequired || reason.trim() !== '';
    }
    return false;
}

export function requiresStillConfidentialConfirmation(
    isConfidential: boolean,
    decision: ConfidentialityDecision | null,
    reason: string
): boolean {
    return isConfidential && decision === ConfidentialityDecision.KEEP && reason.trim() === '';
}
